// Conversions de fuseau côté navigateur, sans dépendance (Intl gère les fuseaux
// IANA et l'heure d'été). Miroir de utils/timezone.js côté serveur.
//
// Rappel de la convention : un créneau ("YYYY-MM-DD" + "HH:MM") est une heure
// locale du fuseau de l'agence de l'EXPERT. On le convertit ici pour l'afficher
// dans le fuseau de l'assuré — mais on renvoie toujours au serveur la valeur
// d'origine (celle de l'expert).

const pad = (n) => String(n).padStart(2, "0");

function getPartsInTimeZone(date, timeZone) {
  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  }).formatToParts(date);

  const get = (type) => Number(parts.find((p) => p.type === type).value);

  return {
    year: get("year"),
    month: get("month"),
    day: get("day"),
    hour: get("hour") % 24,
    minute: get("minute"),
    second: get("second"),
  };
}

function getTimeZoneOffsetMs(date, timeZone) {
  const p = getPartsInTimeZone(date, timeZone);
  return (
    Date.UTC(p.year, p.month - 1, p.day, p.hour, p.minute, p.second) -
    date.getTime()
  );
}

// Heure locale naïve d'un fuseau -> instant absolu.
export function zonedTimeToUtc(dateStr, timeStr, timeZone) {
  if (!dateStr || !timeStr) return null;

  const [year, month, day] = String(dateStr).split("-").map(Number);
  const [hour, minute] = String(timeStr).split(":").map(Number);
  const wanted = Date.UTC(year, month - 1, day, hour, minute || 0, 0);

  // Heure non-parsable ("NC"...) -> null, pas de Date invalide qui ferait
  // planter Intl.
  if (Number.isNaN(wanted)) return null;

  // Le décalage dépend de l'instant, et l'instant du décalage : on estime, puis
  // on corrige (nécessaire au moment des changements d'heure).
  let instant = new Date(
    wanted - getTimeZoneOffsetMs(new Date(wanted), timeZone)
  );
  instant = new Date(wanted - getTimeZoneOffsetMs(instant, timeZone));

  return instant;
}

// Convertit un créneau du fuseau de l'expert vers celui de l'assuré.
export function convertSlot(dateStr, timeStr, fromTimeZone, toTimeZone) {
  if (!fromTimeZone || !toTimeZone || fromTimeZone === toTimeZone) {
    return { date: dateStr, time: timeStr };
  }
  const instant = zonedTimeToUtc(dateStr, timeStr, fromTimeZone);
  // Heure non-parsable : on retombe sur la valeur d'origine (pas de crash).
  if (!instant) return { date: dateStr, time: timeStr };

  const p = getPartsInTimeZone(instant, toTimeZone);

  return {
    date: `${p.year}-${pad(p.month)}-${pad(p.day)}`,
    time: `${pad(p.hour)}:${pad(p.minute)}`,
  };
}

// Libellé court d'un fuseau, pour lever toute ambiguïté à l'écran.
export function getTimeZoneLabel(timeZone) {
  if (!timeZone) return "";
  return timeZone.split("/").pop().replace(/_/g, " ");
}
